const Application = {
  props: {
    application: {
      default: {},
    },
  },
  methods: {
    goToMessages(application) {
      if (application.status === 'closed') return;
      this.$router.push(`mensajes/${application.thread}`);
    },
    closeApplication(application) {
      customConfirm(
        '¿Seguro que deseas eliminar esta inscripción?',
        'Si lo haces no podrás volver a apuntarte ni continuar los mensajes con el empleador.',
      )
        .then(() => {
          //Cerramos aplicación
          application.status = 'closed';
          this.$dmtk.applications.close(application._id).catch(console.error);

          //Cambiamos el número en el usuario
          this.$store.commit('removeUserApplication');
        })
        .catch(() => console.log('No borramos'));
    },
  },
  template: `
      <div class="uk-grid">
      <div class="info uk-width-expand" @click="goToMessages(application)">
        <strong>{{ application.job.title }}</strong><br>
        {{ application.job.activity.name }} en {{ application.job.location.title }}<br>
        <small>
          Inscrito <span
            :title="application.createdAt | dateFormat">{{ application.createdAt | relativeTime }}</span>
        </small>
        |
        <small>Inscripción</small>
        <small v-if="application.status === 'active'">Activa</small>
        <small v-else>Cerrada</small>
        |
        <small>Oferta</small>
        <small v-if="application.job.status === 'active'">Activa</small>
        <small v-else>Cerrada</small>
      </div>
      <div>
        <button class="uk-button uk-button-ellipsis" v-if="application.status === 'active'"></button>
        <div uk-dropdown="mode: click">
          <ul class="uk-nav uk-dropdown-nav">
            <li v-if="application.job.status === 'active'">
              <a :href="'/empleo/oferta/'+application.job.slug+'/'" target="_blank">Ver oferta</a>
            </li>
            <li v-if="application.status === 'active'">
              <a @click="goToMessages(application)">Ver mensajes</a>
            </li>
            <li v-if="application.status === 'active'">
              <a
                  class="uk-text-danger"
                  @click="closeApplication(application)"
              >Cancelar inscripción</a>
            </li>
          </ul>
        </div>
      </div>
      </div>
	`,
};
